import { useMemo } from 'react';
import { renderMarkdown } from '@/lib/markdown';

export function Markdown({ source }: { source?: string | null }) {
  const html = useMemo(() => (source ? renderMarkdown(source) : ''), [source]);
  if (!source) return <div className="text-sm text-ink-500">Aucun contenu.</div>;
  return <div className="markdown-body" dangerouslySetInnerHTML={{ __html: html }} />;
}
